<template>
  <div v-show="!props.hidden && hasPinnedMessage" class="pin-message-wrapper">
    <div class="pin-message">
      <base-icon v-if="isShowPinnedIcon" class="keep" icon-name="keep" width="20" height="20" view-box="0 -960 960 960">
        <keep-icon></keep-icon>
      </base-icon>
      <div class="chat-message" v-html="newMessage?.text || auctionStore.pinMessage?.text"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { BaseIcon, KeepIcon } from "@/components/icons";
  import { computed, inject, ref } from "vue";
  import { IMessage } from "@/models";
  import { useAuctionStore } from "@/stores/AuctionStore";

  const props = withDefaults(defineProps<{
      hidden?: boolean;
    }>(),
    {
      hidden: false
  });

  const emitter = inject("emitter");
  const auctionStore = useAuctionStore();
  const newMessage = ref<IMessage | null>(null);
  const resetPinedMessageTimerId = ref<number | null>(null);

  const hasPinnedMessage = computed(() => {
    return auctionStore.pinMessage?.id || newMessage.value?.id;
  });

  const isShowPinnedIcon = computed(() => {
    return !newMessage.value?.text || auctionStore.pinMessage?.id === newMessage.value?.id;
  });

  emitter?.on("on:chat-new-message", (message: IMessage) => {
    newMessage.value = message;

    if (resetPinedMessageTimerId.value) {
      clearTimeout(resetPinedMessageTimerId.value);
    }

    resetPinedMessageTimerId.value = setTimeout(() => {
      newMessage.value = null;
    }, (auctionStore.newMessagePinSeconds || 60) * 1000);
  });
</script>